import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia?',
  answer: <span data-id="element-9">
        No. <strong data-id="element-10">No necesitas experiencia</strong>. Está explicado desde
        cero, con pasos claros.
      </span>
}, {
  question: '¿De verdad no tengo que mostrar mi cara?',
  answer: <span data-id="element-11">
        Correcto. <strong data-id="element-12">No mostrar tu cara</strong> es el punto: construir sin
        exposición.
      </span>
}, {
  question: '¿Cuánto tiempo necesito?',
  answer: <span data-id="element-13">
        Para empezar: 2–4 horas la primera semana. Después:{' '}
        <strong data-id="element-14">20–30 min al día</strong> para mantener constancia.
      </span>
}, {
  question: '¿Sirve para cualquier nicho?',
  answer: <span data-id="element-15">
        Sí. Te damos la metodología y ejemplos para adaptarlo a distintos
        nichos.
      </span>
}, {
  question: '¿Cómo lo recibo?',
  answer: <span data-id="element-16">
        Tras el pago, recibes el acceso por email.{' '}
        <strong data-id="element-17">Acceso inmediato</strong>, descarga directa.
      </span>
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 bg-alt" data-id="element-18">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <h2 className="text-3xl font-serif text-center text-title mb-12" data-id="element-20">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <div key={index} className="bg-card border border-[#D9D0C1] overflow-hidden" data-id="element-22">
              <button className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-23">
                <span className={`font-medium ${openIndex === index ? 'text-accent' : 'text-title'}`} data-id="element-24">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus size={20} className="text-accent" data-id="element-25" /> : <Plus size={20} className="text-body" data-id="element-26" />}
              </button>

              <div className={`px-6 text-body text-sm transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 py-4 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-27">
                {faq.answer}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}